import type { CursorShape } from '@viewer/protocol';

export interface RemoteCursorImage {
  url: string;
  hotspotX: number;
  hotspotY: number;
}

/** O que o ponteiro local imita do cursor do Host. */
export interface RemoteCursorLook {
  visible: boolean;
  /** `null`: a imagem ainda não chegou; fica o ponteiro padrão. */
  image: RemoteCursorImage | null;
}

export function cursorImage(shape: CursorShape): RemoteCursorImage {
  const pixels = Uint8ClampedArray.from(atob(shape.rgba), (c) => c.charCodeAt(0));
  const canvas = document.createElement('canvas');
  canvas.width = shape.width;
  canvas.height = shape.height;
  canvas.getContext('2d')?.putImageData(new ImageData(pixels, shape.width, shape.height), 0, 0);
  return { url: canvas.toDataURL('image/png'), hotspotX: shape.hotspotX, hotspotY: shape.hotspotY };
}

const GUIDE_ARROW =
  '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="22"><path d="M1 1v16l4-4 3 7 3-1-3-7h5z" fill="#4caf50" stroke="#1b5e20" stroke-linejoin="round"/></svg>';

/** No modo guia o ponteiro local vira a mesma seta verde que aparece na tela do Host. */
export const GUIDE_POINTER = `url("data:image/svg+xml,${encodeURIComponent(GUIDE_ARROW)}") 1 1, default`;

/** Valor de `cursor` do CSS para a tela remota. */
export function pointerStyle(look: RemoteCursorLook | null): string | undefined {
  if (!look) return undefined;
  if (!look.visible) return 'none';
  if (!look.image) return undefined;
  return `url(${look.image.url}) ${look.image.hotspotX} ${look.image.hotspotY}, default`;
}
